/**
 * @desc 导出明细列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {
  /** 查询对应的Id */
  id: number
}

export function request(data: QueryParams): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/invoice/exportDetailList',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
